import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fa4cb7fe&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa4cb7fe')) {
      api.createRecord('fa4cb7fe', component.options)
    } else {
      api.reload('fa4cb7fe', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fa4cb7fe&", function () {
      api.rerender('fa4cb7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-41eEIz398RefR/JS/comp/ErrorMessage.vue"
export default component.exports